export const basename = () => '';
export const join = (...parts) => parts.filter(Boolean).join("/");
export default { basename, join };
